<template>
<div class="styled-interaction h-100">
    <app-loader v-if="appLoading || itemLoading" variant="light" />

    <div class="h-100" v-show="!appLoading && !itemLoading">
        <div v-if="isPartIntroItem" class="overflow-hidden">
            <part-intro-page
                @click="handleNext"
                :isLoading="isLoading"
                :buttonDisabled="!itemAnswered"
                :buttonHidden="isLastItem"
                :header="$t(activePart.text)"
                :icon="ASSETS_URL + $t(`${currentItem.text}_ICON`)"
                :variant="colorVariant"
            >
                <item-container
                    class="styled-interaction__content"
                    :item="currentItem"
                    :interactionInstanceToken="interactionInstanceToken"
                    :nextClicked="nextClicked"
                    @answer="handleAnswer"
                    @answered="resetData"
                />
            </part-intro-page>
        </div>
        <div v-else class="h-100">
            <bq-color-page
                class="h-100"
                @click="handleNext"
                :navDisabled="!itemAnswered"
                :navHidden="isLastItem"
                :isLoading="isLoading"
                :whitelabel-config="whitelabelConfig"
                :currentItem="currentItem"
            >
                <item-container
                    class="styled-interaction__content h-100"
                    :item="currentItem"
                    :interactionInstanceToken="interactionInstanceToken"
                    :nextClicked="nextClicked"
                    @answer="handleAnswer"
                    @answered="resetData"
                />
            </bq-color-page>
        </div>
    </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import { STYLE_ITEM } from '@/constants/items'
import { ASSETS_URL } from '@/constants/misc' 

import InteractionContainerMixin from '@/containers/Interaction/mixins/InteractionContainerMixin'
import colorVariantMixin from '@/components/mixins/colorVariantMixin'

import ItemContainer from '@/containers/Items/ItemContainer'
import bqColorPage from '@/components/ui/bqColorPage'
import partIntroPage from '@/components/ui/partIntroPage'

export default {
    name: 'StyledInteractionContainer',
    mixins: [
        InteractionContainerMixin,
        colorVariantMixin
    ],
    components: {
        'item-container': ItemContainer,
        'bq-color-page': bqColorPage,
        'part-intro-page': partIntroPage,
    },
    data() {
        return {
            ASSETS_URL
        }
    },
    computed: {
        ...mapGetters([
            'appLoading',
            'itemLoading',
            'isLoading',
            'whitelabelConfig'
        ]),
        isPartIntroItem() {
            return this.currentItem && 
                this.currentItem.properties && 
                this.currentItem.properties.find(prop => prop.name === STYLE_ITEM && prop.value === 'part_intro')
        },
    }
}
</script>
<style lang="scss">
.styled-interaction {
    &-bq-burgundy {
        background-color: $bq-burgundy;
    }

    &-bq-green {
        background-color: $bq-green;
    }

    &-bq-blue {
        background-color: $bq-blue;
    }

    &-bq-turquoise {
        background-color: $bq-turquoise;
    }

    &-bq-orange {
        background-color: $bq-orange;
    }

    &-bq-red {
        background-color: $bq-red;
    }
}

.part-intro__header {
    margin: 0 -15px;
    @media screen and (min-width: 1200px) {
        padding: 0 110px;
    }
}

.styled-interaction__content {
    padding-bottom: 80px;
    padding-top: 1rem;

    @media screen and (min-width: 992px) {
        padding-top: 40px;
    }
}
</style>
